var exports = {
  "VH": "ForwardMessagePreview.module__preview___bEJYYU",
  "Qs": "ForwardMessagePreview.module__content___bEJYYU",
  "iU": "ForwardMessagePreview.module__message___bEJYYU",
  "Mg": "ForwardMessagePreview.module__messageWithAttachments___bEJYYU",
  "oh": "ForwardMessagePreview.module__edited___bEJYYU",
  "kp": "ForwardMessagePreview.module__attachmentRow___bEJYYU",
  "$r": "ForwardMessagePreview.module__attachmentIcon___bEJYYU",
  "eI": "ForwardMessagePreview.module__attachmentSummary___bEJYYU",
  "rs": "ForwardMessagePreview.module__attachmentSummaryWithText___bEJYYU",
  "vH": "ForwardMessagePreview.module__thumbnailStack___bEJYYU",
  "xn": "ForwardMessagePreview.module__thumbnail___bEJYYU",
  "q_": "ForwardMessagePreview.module__thumbnailImage___bEJYYU",
  "SK": "ForwardMessagePreview.module__thumbnailPlaceholder___bEJYYU",
  "XX": "ForwardMessagePreview.module__thumbnailPlaceholderIcon___bEJYYU",
  "Uy": "ForwardMessagePreview.module__thumbnailVideo___bEJYYU",
  "tk": "ForwardMessagePreview.module__thumbnailSensitive___bEJYYU",
  "$3": "ForwardMessagePreview.module__thumbnailWithOverflow___bEJYYU",
  "uZ": "ForwardMessagePreview.module__playIcon___bEJYYU",
  "mB": "ForwardMessagePreview.module__overflowCount___bEJYYU",
};

module.exports = exports;
